import type { FeaturesRepository } from "../../repositories/features/features.repository";
import type { FeaturesModel } from "../..//models/features.model";

export default class FeaturesController {
  constructor(private featuresRepository: FeaturesRepository) {
  }

  async getFeatures(brand?: string): Promise<FeaturesModel> {
    return await this.featuresRepository.getFeatures(brand);
  }
}
